'use client';

import { MovieFanIcon } from '@/components/icons/movie-fan-icon';
import { Anchor } from '@/components/ui/anchor';
import { AnalyticsPageCategories } from '@/enums/analytics-type';
import { useDataAnalytics } from '@/hooks/analytics/analytics';
import { MovieRewardsInfo } from '@cinemark/content-api-client';
import { Benefit } from './benefit';
import { getBenefits, shouldShowSection } from './benefit-helpers';

type MovieRewardsInfoImageHeaderProps = {
  hideCTA?: boolean;
  movieRewardsInfo: MovieRewardsInfo;
};

export const MovieFanSection = ({ hideCTA, movieRewardsInfo }: MovieRewardsInfoImageHeaderProps): React.JSX.Element | null => {
  const { trackClick } = useDataAnalytics();

  const benefits = getBenefits(movieRewardsInfo, 'movie-fan');
  const hasCTA = !hideCTA && !!movieRewardsInfo.movieFanSignedOutButtonCTA;

  if (!shouldShowSection(movieRewardsInfo.movieFanSignedOutHeader, benefits.length, hasCTA)) {
    return null;
  }

  return (
    <div className="flex flex-col items-center gap-md py-lg px-ms bg-[var(--color-movie-fan-info)] text-white rounded-sm">
      <MovieFanIcon />

      {movieRewardsInfo.movieFanSignedOutHeader && <h2 data-test="movie-fan-header">{movieRewardsInfo.movieFanSignedOutHeader}</h2>}

      {!!benefits.length &&
        <div className="flex items-center md:w-full">
          <div className="flex flex-col gap-sm w-full md:flex-row md:justify-between">
            {benefits.map((benefit, index) =>
              <Benefit key={index}
                benefitIndex={index + 1}
                header={benefit.header}
                image={benefit.image}
                imageSmall={benefit.imageSmall}
                text={benefit.text}
                type="movie-fan"
              />
            )}
          </div>
        </div>
      }

      {hasCTA &&
        <Anchor className="justify-self-center"
          data-test="link-movie-fan-cta"
          href="/membership/register?returnurl=/movie-rewards-info"
          size="lg"
          onClick={() => trackClick({
            linkCategory: AnalyticsPageCategories.MOVIE_REWARDS,
            linkName: 'Movie Fan CTA',
          })}
        >
          {movieRewardsInfo.movieFanSignedOutButtonCTA}
        </Anchor>
      }
    </div>
  );
};
